/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import './css/DatesBar.css';
import { ReactComponent as Bolt } from '../../../images/yellow-bolt-r.svg';
import { ReactComponent as Moon } from '../../../images/gray-night-r.svg';
import { formatPrice } from '../../../Utils/CommonUtils';
import PriceText from '../../PriceText/PriceText';

function DatesBar(props) {
  const { dates, handleDateClick, selected, minPriceIndex } = props;
  const [activeIndex, setActiveIndex] = useState(0);
  const [lastIndex, setLastIndex] = useState();
  const swipeRef = useRef();

  const slideLeft = () => {
    if (swipeRef.current) {
      swipeRef.current.slideNext();
    }
  };

  const slideRight = () => {
    if (swipeRef.current) {
      swipeRef.current.slidePrev();
    }
  };

  const getSwipeItemDateClass = (id) => {
    if (id === selected) {
      return 'bm_text_16 mb_5';
    } else {
      return 'gr_text_16 mb_5';
    }
  };

  const getSwipeItemClass = (id) => {
    if (id === selected) {
      return 'dates_bar_swipe_item db_swipe_acive';
    } else {
      return 'dates_bar_swipe_item light_gray_button';
    }
  };

  const getSwipeItemPriceClass = (id) => {
    if (id === selected) {
      return 'bluem_text_14';
    } else {
      return 'gr_text_14';
    }
  };

  const getLeftButton = () => {
    if (activeIndex === 0) {
      return <div className="datesbar_inactive_swipe_button_left"></div>;
    } else {
      return (
        <button
          type="button"
          className="datesbar_swipe_button_left"
          onClick={() => slideRight()}
        ></button>
      );
    }
  };

  const getRightButton = () => {
    if (lastIndex <= 0 || activeIndex === lastIndex) {
      return <div className="datesbar_inactive_swipe_button_right"></div>;
    } else {
      return (
        <button
          type="button"
          className="datesbar_swipe_button_right"
          onClick={() => slideLeft()}
        ></button>
      );
    }
  };

  return (
    <div className="dates_bar_w">
      {lastIndex > 0 && getLeftButton()}
      <div className="dates_bar_swiper_w">
        {dates.length > 0 && (
          <Swiper
            modules={[Pagination, Scrollbar, A11y]}
            spaceBetween={4}
            scrollbar={{ draggable: true }}
            onBreakpoint={(swiper) => {
              setLastIndex(swiper.slides.length - swiper.params.slidesPerView);
            }}
            onSwiper={(swiper) => {
              setLastIndex(swiper.slides.length - swiper.params.slidesPerView);
              swipeRef.current = swiper;
              swiper.slideTo(minPriceIndex);
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
            observer
            observeParents
            slidesPerView="auto"
            breakpoints={{
              650: {
                slidesPerView: 5,
              },
              870: {
                slidesPerView: 6,
              },
              990: {
                slidesPerView: 7,
              },
              1110: {
                slidesPerView: 8,
              },
              1230: {
                slidesPerView: 9,
              },
              1350: {
                slidesPerView: 10,
              },
            }}
          >
            {dates.map((date, index) => {
              const id = `date-${index}`;
              return (
                <SwiperSlide key={index}>
                  <button
                    type="button"
                    className={getSwipeItemClass(id)}
                    onClick={() => handleDateClick(id)}
                  >
                    <div className={getSwipeItemDateClass(id)}>
                      {date.formattedDate}
                    </div>
                    <div className="db_min_price_w mb_3">
                      {index === minPriceIndex && (
                        <Bolt className="db_bolt_ico" />
                      )}
                      <div
                        className={getSwipeItemPriceClass(id)}
                      >
                        <PriceText
                          text={`от ${formatPrice(date.dayMinPrice)} ${date.currency}`}
                        />
                      </div>
                    </div>
                    <div className="db_price_night_w">
                      <div className="gr_text_12">
                        <PriceText
                          text={`${formatPrice(date.dayMinPricePerNight)} ${date.currency} / `}
                        />
                      </div>
                      <Moon className="db_moon_ico" />
                    </div>
                  </button>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>
      {lastIndex > 0 && getRightButton()}
    </div>
  );
}

DatesBar.propTypes = {
  dates: PropTypes.instanceOf(Array).isRequired,
  handleDateClick: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
  minPriceIndex: PropTypes.number.isRequired,
};

export default DatesBar;
